/* WR CART RECS — fills every [data-wr-cart-recs] slot (cart drawer + cart page)
   with recommendations for the most recently added cart item, via the Section
   Rendering API (section: wr-cart-recs). intent=complementary first (uses
   Search & Discovery pairings when configured), falls back to the algorithmic
   intent=related. Refreshes after any cart mutation. Fails silent. */
(function () {
  'use strict';
  if (window.__wrCartRecs) return;
  window.__wrCartRecs = true;

  var BUSY = false;
  var LAST_PID = null;

  function slots() {
    return document.querySelectorAll('[data-wr-cart-recs]');
  }

  function inject(html) {
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    var content = tpl.content.querySelector('.complementary-products');
    slots().forEach(function (slot) {
      slot.innerHTML = content ? content.outerHTML : '';
    });
  }

  function fetchSection(pid, intent) {
    return fetch(
      '/recommendations/products?section_id=wr-cart-recs&product_id=' +
        pid + '&limit=8&intent=' + intent
    )
      .then(function (r) { return r.ok ? r.text() : ''; })
      /* network failure (offline/abort) resolves to empty instead of
         rejecting — otherwise the rejection escapes refresh()'s outer
         catch and BUSY stays true, freezing recs until reload. */
      .catch(function () { return ''; });
  }

  function refresh() {
    if (BUSY || !slots().length) return;
    BUSY = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          inject('');
          BUSY = false;
          return;
        }
        var pid = cart.items[0].product_id; /* newest line first */
        LAST_PID = pid;
        fetchSection(pid, 'complementary').then(function (html) {
          if (html && html.indexOf('data-wr-recs-count') !== -1) {
            inject(html);
            BUSY = false;
          } else {
            fetchSection(pid, 'related').then(function (html2) {
              inject(html2 && html2.indexOf('data-wr-recs-count') !== -1 ? html2 : '');
              BUSY = false;
            });
          }
        });
      })
      .catch(function () { BUSY = false; });
  }

  /* re-render after any cart mutation */
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refresh, 350); });
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
